import React from "react";
import { Link } from "react-router-dom";
import "./Pricing.css";
import { FiLayers, FiTrendingUp, FiBriefcase, FiAward } from "react-icons/fi";

const packages = [
  {
    key: "basic",
    title: "Basic Website",
    icon: FiLayers,
    badge: "Starter",
    description: "Single-page business website with everything you need to go online fast.",
    details: [
      "Single-page business website",
      "Supports up to 5 customer images",
      "Mobile responsive design",
      "Business name, address, phone, email",
      "Google Maps section",
      "WhatsApp click-to-chat button",
      "Basic contact form",
      "Social media links",
      "SEO-friendly page title and description",
      "Delivery-ready static website",
    ],
    price: "₹2,500 – ₹5,000",
  },
  {
    key: "advanced",
    title: "Advanced Website",
    icon: FiBriefcase,
    badge: "Popular",
    description: "Multi-page website for growing businesses that need more pages and polish.",
    details: [
      "Multi-page business website",
      "Supports up to 10 customer images",
      "Home, About, Services/Products, Gallery, Contact pages",
      "Mobile, tablet, desktop responsive",
      "WhatsApp integration",
      "Google Maps integration",
      "Contact form",
      "Basic SEO setup",
      "Fast-loading optimized UI",
      "Minimal support included",
    ],
    price: "₹5,001 – ₹15,000",
  },
  {
    key: "premium",
    title: "Premium Website",
    icon: FiTrendingUp,
    badge: "Growth",
    description: "Premium multi-page site with admin portal and lead management built in.",
    details: [
      "Premium multi-page website",
      "Supports up to 20 customer images",
      "Modern UI/UX with animations",
      "Admin portal for controlling website content",
      "Product/service management",
      "Gallery management",
      "Enquiry/contact lead management",
      "WhatsApp and Google Maps integration",
      "SEO-friendly structure",
      "Performance optimization",
      "Domain purchase up to ₹1,000 free",
    ],
    price: "₹15,001 – ₹50,000",
  },
  {
    key: "enterprise",
    title: "Enterprise Website",
    icon: FiAward,
    badge: "Enterprise",
    description: "Enterprise-grade solution with advanced admin, analytics, and dedicated support.",
    details: [
      "Enterprise-grade multi-page website",
      "Supports 30+ customer images",
      "Custom business workflow pages",
      "Advanced admin portal",
      "Role-based admin users",
      "Lead/enquiry management",
      "Product/service catalog management",
      "Blog/news/events module if required",
      "Advanced SEO structure",
      "Analytics-ready setup",
      "WhatsApp, Google Maps, and social integrations",
      "Domain purchase up to ₹2,000 free",
    ],
    price: "₹50,001+",
  },
];

function Pricing({ standalone = false }) {
  return (
    <section id="main-section" className={`pricing-section ${standalone ? "pricing-section-page" : ""}`}>
      <div className="pricing-shell">
        <div className="pricing-header">
          <p className="pricing-eyebrow">Packages We Offer</p>
          <h1 className="pricing-title">Choose the package that fits your business</h1>
          <p className="pricing-subtitle">
            Professional websites for shops, salons, clinics, restaurants and more — starting from just ₹2,500.
          </p>
        </div>

        <div className="pricing-grid">
          {packages.map((item) => (
            <article
              className={`pricing-card${item.key === "premium" ? " pricing-card-featured" : ""}`}
              key={item.key}
            >
              <div className="pricing-card-top">
                <span className="pricing-badge">{item.badge}</span>
                <div className="pricing-icon-wrap" aria-hidden="true">
                  <item.icon className="pricing-icon" />
                </div>
              </div>
              <h2 className="pricing-card-title">{item.title}</h2>
              <p className="pricing-card-description">{item.description}</p>
              <ul className="pricing-card-details">
                {item.details.map((detail) => (
                  <li key={detail}>{detail}</li>
                ))}
              </ul>
              <div className="pricing-card-footer">
                <p className="pricing-amount">{item.price}</p>
                <Link
                  to={`/get-started?package=${encodeURIComponent(item.title)}`}
                  className="pricing-button"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Get Started
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Pricing;
